import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseCliScript1 from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScript1';

const pageSchema = GatewayGetSchema.pages.cliScript1;
const pageId = pageSchema.pageId;

function PlanCliScript1({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseCliScript1
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanCliScript1;